/** Converts underscore-separated strings to space-separated. e.g. "aw_test_we" → "aw test we" */
export const formatLabel = (label) => label?.replace(/_/g, " ") ?? "";
